module.exports = __webpack_public_path__ + "img/logo-light.a8bf4e08.png";